/**
 * Anomaly presentation helpers — category labels, priority labels, sorting.
 * Copy follows the spec framing (TZ §9): помогаем сотруднику, объективная картина —
 * не «слежка ради штрафов».
 */
import type {
  AnomalyCard,
  AnomalyCategory,
  AnomalyPriority,
} from "@/types/contract";
import type { BadgeTone } from "@/components/ui/Badge";

export const CATEGORY_LABELS: Record<AnomalyCategory, string> = {
  service: "Сервис",
  kitchen: "Кухня",
  loss_prevention: "Сохранность",
  receiving: "Приёмка",
  hygiene: "Гигиена",
  flow: "Поток гостей",
  conflict: "Сигнал персоналу",
};

export const CATEGORY_ORDER: AnomalyCategory[] = [
  "service",
  "kitchen",
  "loss_prevention",
  "receiving",
  "hygiene",
  "flow",
  "conflict",
];

/** Priority → tone for the indicator. 5 = критический. */
export function priorityTone(p: AnomalyPriority): BadgeTone {
  if (p >= 5) return "danger";
  if (p >= 4) return "warning";
  if (p >= 3) return "neutral";
  return "neutral";
}

export const PRIORITY_LABELS: Record<AnomalyPriority, string> = {
  1: "Низкий",
  2: "Низкий",
  3: "Средний",
  4: "Высокий",
  5: "Критический",
};

/** Sort by priority desc, then created_at desc (newest first). */
export function sortAnomalies(list: AnomalyCard[]): AnomalyCard[] {
  return [...list].sort((a, b) => {
    if (b.priority !== a.priority) return b.priority - a.priority;
    return b.created_at.localeCompare(a.created_at);
  });
}

/** Human labels for known linked_data keys (POS / shift / warehouse correlation). */
export const LINKED_LABELS: Record<string, string> = {
  table_no: "Стол",
  wait_seconds: "Ожидание, с",
  zone: "Зона",
  staff: "На смене",
  shift_staff: "Смена",
  pos_exception_type: "Тип операции",
  amount: "Сумма, ₸",
  receipt_no: "Чек",
  checkout_id: "Касса",
  station: "Станция",
  deviation_pct: "Отклонение, %",
  orders_in_hour: "Заказов за час",
  norm_per_hour: "Норма за час",
  invoice_no: "Накладная",
  expected_units: "Ожидалось, шт",
  detected_units: "Принято, шт",
  shortage_units: "Недовоз, шт",
  line_count: "Позиций",
  total_amount: "Сумма, ₸",
  supplier: "Поставщик",
  violation: "Нарушение",
  dish: "Блюдо",
  employee: "Кто отменил",
  order_no: "Заказ",
  quantity: "Кол-во",
  void_id: "ID отмены",
  sent_to_kitchen_at: "На кухню",
  voided_at: "Отменено",
  source: "Источник",
  clip_note: "О фрагменте",
  queue_len: "Длина очереди",
  balk_count: "Ушли без посадки",
  needs_review: "Требует проверки",
};
